import { UserType } from "@bvhi/backend-api/apis";
import { useRouterState } from "@tanstack/react-router";
import { useMemo } from "react";
import { BVHIRoute } from "../config/navigation";
import { useAuthContext } from "../context/use-auth-context";
import { hasFeatureEnabled } from "../utils/env-helper.ts";
import { usePermissions } from "./use-permissions";
import { useRouteConfig } from "./use-route-config";

export const useRoutePermissionChecker = () => {
  const { currentUser } = useAuthContext();
  const { getBVHIRouteForId } = useRouteConfig();
  const { canNavigateTo } = usePermissions();
  const routerState = useRouterState();

  const routeEnabled = useMemo(() => {
    let bvhiRoute: BVHIRoute | null = null;
    let routeId: string | undefined = routerState.matches.at(-1)?.routeId;
    if (!routeId) return;
    if (routeId.at(-1) === "/") {
      routeId = routeId.slice(0, -1);
    }
    bvhiRoute = getBVHIRouteForId(routeId);
    if (!bvhiRoute) return false;

    const orderApiEnabled = hasFeatureEnabled("ENABLE_ORDER_API");
    const cr3AudiologistEnabled = hasFeatureEnabled("ENABLE_CR3_AUDIOLOGIST");

    const shouldAllowPosAndSettings =
      currentUser?.type === UserType.AUDIOLOGIST ? orderApiEnabled && cr3AudiologistEnabled : orderApiEnabled;

    if (!shouldAllowPosAndSettings && bvhiRoute?.id.includes("pos")) {
      return false;
    }

    if (!shouldAllowPosAndSettings && bvhiRoute?.id.includes("settings")) {
      return false;
    }

    if (!orderApiEnabled && bvhiRoute?.id.includes("messages")) {
      return false;
    }

    if (!orderApiEnabled && currentUser?.type === UserType.SUPPLIER && bvhiRoute?.id.includes("api-token")) {
      return false;
    }

    if (!currentUser?.permissions) return false;
    return canNavigateTo(bvhiRoute);
  }, [getBVHIRouteForId, routerState.matches, currentUser, canNavigateTo]);

  return routeEnabled;
};
